import { Controller } from "@hotwired/stimulus"
import TomSelect from "tom-select"

export default class extends Controller {
  static values = {
    isHybrid85: Boolean,
    order: Object,
    supplier: Object,
  }
  static targets = [
    "OrderSelect",
    "SupplierSelect",
    "OrderIdInput",
    "IsH85",
    "IsCCE",
    "Salesperson",
    "CustomerName",
    "Line1Quantity",
    "Line1DescriptionInput",
    "Line1DescriptionSelect",
    "Line1Treatment",
    "Line1LotNumberContainer",
    "Line1LotNumberInput",
    "Line1LotNumberSelect",
    "Line1WarehouseLocationContainer",
    "Line1WarehouseLocation",
    "Line2Quantity",
    "Line2DescriptionInput",
    "Line2DescriptionSelect",
    "Line2Treatment",
    "Line2LotNumberContainer",
    "Line2LotNumberInput",
    "Line2LotNumberSelect",
    "Line2WarehouseLocationContainer",
    "Line2WarehouseLocation",
    "Line3Quantity",
    "Line3DescriptionInput",
    "Line3DescriptionSelect",
    "Line3Treatment",
    "Line3LotNumberContainer",
    "Line3LotNumberInput",
    "Line3LotNumberSelect",
    "Line3WarehouseLocationContainer",
    "Line3WarehouseLocation",
    "Line4Quantity",
    "Line4DescriptionInput",
    "Line4DescriptionSelect",
    "Line4Treatment",
    "Line4LotNumberContainer",
    "Line4LotNumberInput",
    "Line4LotNumberSelect",
    "Line4WarehouseLocationContainer",
    "Line4WarehouseLocation",
    "Line5Quantity",
    "Line5DescriptionInput",
    "Line5DescriptionSelect",
    "Line5Treatment",
    "Line5LotNumberContainer",
    "Line5LotNumberInput",
    "Line5LotNumberSelect",
    "Line5WarehouseLocationContainer",
    "Line5WarehouseLocation",
    "Line6Quantity",
    "Line6DescriptionInput",
    "Line6DescriptionSelect",
    "Line6Treatment",
    "Line6LotNumberContainer",
    "Line6LotNumberInput",
    "Line6LotNumberSelect",
    "Line6WarehouseLocationContainer",
    "Line6WarehouseLocation",
    "Line7Quantity",
    "Line7DescriptionInput",
    "Line7DescriptionSelect",
    "Line7Treatment",
    "Line7LotNumberContainer",
    "Line7LotNumberInput",
    "Line7LotNumberSelect",
    "Line7WarehouseLocationContainer",
    "Line7WarehouseLocation",
    "Line8Quantity",
    "Line8DescriptionInput",
    "Line8DescriptionSelect",
    "Line8Treatment",
    "Line8LotNumberContainer",
    "Line8LotNumberInput",
    "Line8LotNumberSelect",
    "Line8WarehouseLocationContainer",
    "Line8WarehouseLocation",
    "Line9Quantity",
    "Line9DescriptionInput",
    "Line9DescriptionSelect",
    "Line9Treatment",
    "Line9LotNumberContainer",
    "Line9LotNumberInput",
    "Line9LotNumberSelect",
    "Line9WarehouseLocationContainer",
    "Line9WarehouseLocation",
    "Line10Quantity",
    "Line10DescriptionInput",
    "Line10DescriptionSelect",
    "Line10Treatment",
    "Line10LotNumberContainer",
    "Line10LotNumberInput",
    "Line10LotNumberSelect",
    "Line10WarehouseLocationContainer",
    "Line10WarehouseLocation",
    "Line11Quantity",
    "Line11DescriptionInput",
    "Line11DescriptionSelect",
    "Line11Treatment",
    "Line11LotNumberContainer",
    "Line11LotNumberInput",
    "Line11LotNumberSelect",
    "Line11WarehouseLocationContainer",
    "Line11WarehouseLocation",
    "Line12Quantity",
    "Line12DescriptionInput",
    "Line12DescriptionSelect",
    "Line12Treatment",
    "Line12LotNumberContainer",
    "Line12LotNumberInput",
    "Line12LotNumberSelect",
    "Line12WarehouseLocationContainer",
    "Line12WarehouseLocation",
    "Line13Quantity",
    "Line13DescriptionInput",
    "Line13DescriptionSelect",
    "Line13Treatment",
    "Line13LotNumberContainer",
    "Line13LotNumberInput",
    "Line13LotNumberSelect",
    "Line13WarehouseLocationContainer",
    "Line13WarehouseLocation",
    "Line14Quantity",
    "Line14DescriptionInput",
    "Line14DescriptionSelect",
    "Line14Treatment",
    "Line14LotNumberContainer",
    "Line14LotNumberInput",
    "Line14LotNumberSelect",
    "Line14WarehouseLocationContainer",
    "Line14WarehouseLocation",
    "Line15Quantity",
    "Line15DescriptionInput",
    "Line15DescriptionSelect",
    "Line15Treatment",
    "Line15LotNumberContainer",
    "Line15LotNumberInput",
    "Line15LotNumberSelect",
    "Line15WarehouseLocationContainer",
    "Line15WarehouseLocation",
    "Line16Quantity",
    "Line16DescriptionInput",
    "Line16DescriptionSelect",
    "Line16Treatment",
    "Line16LotNumberContainer",
    "Line16LotNumberInput",
    "Line16LotNumberSelect",
    "Line16WarehouseLocationContainer",
    "Line16WarehouseLocation",
    "SupplierName",
    "SupplierPhone",
    "SupplierAddress",
    "SupplierCity",
    "SupplierState",
    "SupplierZipcode",
    "ShippingName",
    "ShippingAddress",
    "ShippingCity",
    "ShippingState",
    "ShippingZipcode",
    "ShippingPhone",
    "SupplierShips",
    "SupplierShipsFieldsContainer",
  ]

  connect() {
    this.element[this.identifier] = this

    window.addEventListener("click", this.onBgClick.bind(this))

    this.initH85TomSelect()

    if (this.isHybrid85Value) {
      this.onIsHybrid85Form()
    }
  }

  lineNumbers() {
    return Array.from(Array(16).keys()).map((i) => i + 1)
  }

  initH85TomSelect() {
    if (this.hasLine1DescriptionSelectTarget) {
      this.lineNumbers().forEach((lineNumber) => {
        this[`Line${lineNumber}DescriptionTomSelect`] = new TomSelect(this[`Line${lineNumber}DescriptionSelectTarget`], { create: true, allowEmptyOption: true, placeholder: "Type or select" })
        this[`Line${lineNumber}LotNumberTomSelect`] = new TomSelect(this[`Line${lineNumber}LotNumberSelectTarget`], { create: true, allowEmptyOption: true, placeholder: "Type or select" })

        // Add event listener to update the original select element's value on change
        this[`Line${lineNumber}DescriptionTomSelect`].on("change", (value) => {
          this[`Line${lineNumber}DescriptionSelectTarget`].value = value
          const textField = this[`Line${lineNumber}DescriptionInputTarget`]
          if (textField) {
            textField.value = value
          }
        })
        this[`Line${lineNumber}LotNumberTomSelect`].on("change", (value) => {
          this[`Line${lineNumber}LotNumberSelectTarget`].value = value
          const textField = this[`Line${lineNumber}LotNumberInputTarget`]
          if (textField) {
            textField.value = value
          }
        })
      })
    }
  }

  onIsH85Change(e) {
    const value = e.currentTarget.value
    this.isHybrid85Value = value

    this.onIsHybrid85Form()
  }

  onBgClick(e) {
    const elems = document.querySelectorAll('[data-controller="form-resource-search"]')
    elems.forEach((elem) => {
      const controllerElem = this.application.getControllerForElementAndIdentifier(elem, "form-resource-search")
      controllerElem.hideResults()
    })
  }

  onSupplierShipsChange(e) {
    if (this.SupplierShipsTarget.checked) {
      this.showSupplierShipsFields()
    } else {
      this.hideSupplierShipsFields()
    }
  }

  showSupplierShipsFields() {
    this.SupplierShipsFieldsContainerTarget.classList.remove("hidden")
    this.fillCustomerShippingFields()
  }

  hideSupplierShipsFields() {
    this.SupplierShipsFieldsContainerTarget.classList.add("hidden")
    this.ShippingNameTarget.value = ""
    this.ShippingAddressTarget.value = ""
    this.ShippingCityTarget.value = ""
    this.ShippingStateTarget.value = ""
    this.ShippingZipcodeTarget.value = ""
    this.ShippingPhoneTarget.value = ""
  }

  fillCustomerShippingFields() {
    if (this.orderValue && this.orderValue.shipping_name) {
      this.CustomerNameTarget.value = this.orderValue.company_name || this.orderValue.billing_name
      this.ShippingNameTarget.value = this.orderValue.shipping_name
      this.ShippingAddressTarget.value = this.orderValue.shipping_address
      this.ShippingCityTarget.value = this.orderValue.shipping_city
      this.ShippingStateTarget.value = this.orderValue.shipping_state
      this.ShippingZipcodeTarget.value = this.orderValue.shipping_zipcode
      this.ShippingPhoneTarget.value = this.orderValue.phone_number
    }
  }

  onFillData(data, resourceType) {
    if (resourceType == "order") {
      this.onFillOrderData(data)
    } else if (resourceType == "supplier") {
      this.onFillSupplierData(data)
    }
  }

  onFillOrderData(order) {
    this.orderValue = order
    this.OrderIdInputTarget.value = order.id

    let units = "lbs"

    // clear previously set order line items
    for (var i = 1; i < 17; i++) {
      this[`Line${i}QuantityTarget`].value = ""
      this[`Line${i}DescriptionInputTarget`].value = ""
      this[`Line${i}TreatmentTarget`].value = ""
      this[`Line${i}LotNumberInputTarget`].value = ""
    }

    this.fillCustomerShippingFields()

    if (order.is_hybrid85 == true) {
      units = "units"
      this.IsH85Target.checked = true
      this.SalespersonTarget.value = "H85"
    } else {
      this.IsCCETarget.checked = true
      this.SalespersonTarget.value = "CCE"
    }
    if (order.order_items.length > 0) {
      let untreatedVal = ""
      if (order.is_hybrid85) {
        untreatedVal = order.untreated_choice ? "NON TREATED" : "Treated"
      } else {
        untreatedVal = "NON TREATED"
      }
      order.order_items.forEach((oi, index) => {
        this[`Line${index + 1}QuantityTarget`].value = `${oi.quantity} ${units}`
        this[`Line${index + 1}DescriptionInputTarget`].value = oi.purchase_order_title
        this[`Line${index + 1}TreatmentTarget`].value = untreatedVal
      })
    }
  }

  onFillSupplierData(supplier) {
    this.SupplierNameTarget.value = supplier.name
    this.SupplierPhoneTarget.value = supplier.phone_number
    this.SupplierAddressTarget.value = supplier.address
    this.SupplierCityTarget.value = supplier.city
    this.SupplierStateTarget.value = supplier.state
    this.SupplierZipcodeTarget.value = supplier.zipcode
    this.SupplierShipsTarget.checked = supplier.ships_parcel_for_us

    if (supplier.ships_parcel_for_us) {
      this.showSupplierShipsFields()
    } else {
      this.hideSupplierShipsFields()
    }
  }

  onIsHybrid85Form() {
    if (this.hasLine1LotNumberContainerTarget) {
      this.lineNumbers().forEach((lineNumber) => {
        // show/hide the lot # and location containers
        if (this[`hasLine${lineNumber}LotNumberContainerTarget`]) {
          if (this.isHybrid85Value) {
            this[`Line${lineNumber}LotNumberContainerTarget`].classList.remove("hidden")
          } else {
            this[`Line${lineNumber}LotNumberContainerTarget`].classList.add("hidden")
          }
        }
        if (this[`hasLine${lineNumber}WarehouseLocationContainerTarget`]) {
          if (this.isHybrid85Value) {
            this[`Line${lineNumber}WarehouseLocationContainerTarget`].classList.remove("hidden")
          } else {
            this[`Line${lineNumber}WarehouseLocationContainerTarget`].classList.add("hidden")
          }
        }

        // show/hide dropdowns for Description and Lot #
        if (this[`hasLine${lineNumber}DescriptionSelectTarget`]) {
          const descriptionTomSelect = this[`Line${lineNumber}DescriptionSelectTarget`].nextSibling
          if (this.isHybrid85Value) {
            this[`Line${lineNumber}DescriptionSelectTarget`].classList.remove("hidden")
            this[`Line${lineNumber}DescriptionInputTarget`].classList.add("hidden")
            descriptionTomSelect.classList.remove("hidden")
          } else {
            this[`Line${lineNumber}DescriptionSelectTarget`].classList.add("hidden")
            this[`Line${lineNumber}DescriptionInputTarget`].classList.remove("hidden")
            descriptionTomSelect.classList.add("hidden")
          }
        }
        if (this[`hasLine${lineNumber}LotNumberSelectTarget`]) {
          const lotNumberTomSelect = this[`Line${lineNumber}LotNumberSelectTarget`].nextSibling
          if (this.isHybrid85Value) {
            this[`Line${lineNumber}LotNumberSelectTarget`].classList.remove("hidden")
            this[`Line${lineNumber}LotNumberInputTarget`].classList.add("hidden")
            lotNumberTomSelect.classList.remove("hidden")
          } else {
            this[`Line${lineNumber}LotNumberSelectTarget`].classList.add("hidden")
            this[`Line${lineNumber}LotNumberInputTarget`].classList.remove("hidden")
            lotNumberTomSelect.classList.add("hidden")
          }
        }
      })
    }
  }

  onLineDescriptionChange(e) {
    const lineNumber = e.currentTarget.dataset.lineNumber
    const hybridName = e.currentTarget.value
    const lotData = this.Line1LotNumberSelectTarget.dataset.lotData
    const selectedHybridLotData = JSON.parse(lotData)[hybridName]
    const lotNumberSelect = this[`Line${lineNumber}LotNumberSelectTarget`]
    lotNumberSelect.innerHTML = ""
    if (selectedHybridLotData) {
      selectedHybridLotData.forEach((lot) => {
        const option = document.createElement("option")
        option.value = lot.lot
        option.text = lot.lot
        option.dataset.location = lot.location
        lotNumberSelect.add(option)
      })
    }
    this[`Line${lineNumber}DescriptionTomSelect`].sync()
    const lotNumberTomSelect = this[`Line${lineNumber}LotNumberTomSelect`]
    lotNumberTomSelect.clear()
    lotNumberTomSelect.clearOptions()
    lotNumberTomSelect.sync()
  }

  onLotNumberChange(e) {
    const lineNumber = e.currentTarget.dataset.lineNumber
    this[`Line${lineNumber}LotNumberTomSelect`].sync()

    const lotNumber = e.currentTarget.selectedOptions[0].value
    if (lotNumber) {
      let hybridName = this[`Line${lineNumber}DescriptionInputTarget`].value
      if (!hybridName) {
        hybridName = this[`Line${lineNumber}DescriptionSelectTarget`].value
      }
      if (!hybridName) {
        hybridName = this[`Line${lineNumber}DescriptionTomSelect`].getValue()
      }
      if (hybridName) {
        const lotData = this.Line1LotNumberSelectTarget.dataset.lotData
        const selectedHybridLotData = JSON.parse(lotData)[hybridName]
        const location = selectedHybridLotData.find((lot) => lot.lot == lotNumber).location
        this[`Line${lineNumber}WarehouseLocationTarget`].value = location
      }
    }
  }
}
